var SdsBaseCarouselFooterSlots = {
    NavigatorPrevious: 'navigatorPrevious',
    NavigatorNext: 'navigatorNext',
    Indicator: 'indicator',
};
var SdsBaseCarouselSlots = {
    Default: 'default',
    Skeleton: 'skeleton',
    Expanded: 'expanded',
};

export { SdsBaseCarouselFooterSlots, SdsBaseCarouselSlots };
